import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, BellOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { enablePushAlerts, checkPushEnabled, pushSupported } from "@/lib/push";

const FAIL = {
  "no-sw": () => toast.info("Add Cross Jobs to your home screen (or open the live site) first, then turn on alerts"),
  denied: () => toast.error("Notifications are blocked. Allow them in your browser or phone settings"),
  unsupported: () => toast.error("This device doesn't support notifications"),
};

// Turns on push notifications on this device so the office hears the moment a client pays by card.
export const PaidAlertsButton = () => {
  const [on, setOn] = useState(false);
  useEffect(() => { checkPushEnabled().then(setOn).catch(() => {}); }, []);
  if (!pushSupported()) return null;
  const click = async () => {
    if (on) {
      const r = await api.pushTest().catch(() => null);
      if (r?.sent > 0) toast.success("Test notification sent. Check your notifications");
      else { setOn(false); toast.info("Alerts aren't active on this device. Tap again to turn them on"); }
      return;
    }
    const r = await enablePushAlerts();
    if (r === "enabled") { setOn(true); toast.success("Paid alerts are on for this device"); api.pushTest().catch(() => {}); }
    else (FAIL[r] || (() => toast.error("Couldn't turn on alerts. Try again")))();
  };
  return (
    <Button variant="outline" onClick={click} className="rounded-full" data-testid="paid-alerts-btn"
      title={on ? "Tap to send a test notification" : "Get a notification when a client pays by card"}>
      {on ? <BellRing className="w-4 h-4 mr-2 text-emerald-600" /> : <BellOff className="w-4 h-4 mr-2" />}{on ? "Paid alerts on" : "Turn on paid alerts"}
    </Button>
  );
};
